import React, { useEffect, useState } from "react";
import Pagination from "../../Component/Common/Pagination";
import Table from "../../Component/Common/Table";
import { connect, useDispatch, useSelector } from "react-redux";
import $ from "jquery";
import UserImage from "../../assets/images/no-profile.jpg";
import { getUserChannels } from "../../store/user/user.action";
import { covertURl } from "../../util/AwsFunction";
import DataActions from "../../Component/Common/DataActions";

function UserChannel(props) {
  const dispatch = useDispatch();
  const { startDate, endDate } = props;

  const [data, setData] = useState();
  const [page, setPage] = useState(1);
  const [size, setSize] = useState(20);
  const { getUserChannel, totalUserChannel } = useSelector(
    (state) => state.user,
  );
  const [showURLs, setShowURLs] = useState([]);

  const [searchText, setSearchText] = useState("");
  const [debounceSearchText, setDebounceSearchText] = useState("");

  useEffect(() => {
    fetchData();
  }, [data]);

  const fetchData = async () => {
    if (!data || data.length === 0) {
      return;
    }

    const urls = await Promise.all(
      data.map(async (item) => {
        const fileNameWithExtension = item.image?.split("/").pop();
        const { imageURL } = await covertURl(
          "userImage/" + fileNameWithExtension,
        );

        return imageURL;
      }),
    );
    setShowURLs(urls);
  };
  $(document).ready(function () {
    $("img").bind("error", function () {
      // Set the default image
      $(this).attr("src", UserImage);
    });
  });
  useEffect(() => {
    dispatch(
      getUserChannels({
        page,
        limit: size,
        startDate,
        endDate,
        type: "realUser",
        searchText: debounceSearchText,
      }),
    );
  }, [dispatch, startDate, endDate, page, size, debounceSearchText]);

  // Debouncing for search text
  useEffect(() => {
    const timer = setTimeout(() => {
      setPage(1);
      setDebounceSearchText(searchText);
    }, 500);

    return () => clearTimeout(timer);
  }, [searchText]);

  useEffect(() => {
    setData(getUserChannel);
  }, [getUserChannel]);

  const channelAllUser = [
    {
      Header: "NO",
      body: "no",
      Cell: ({ index }) => <span className="  text-nowrap">{index + 1}</span>,
    },
    {
      Header: "CHANNEL NAME",
      body: "fullName",
      Cell: ({ row, index }) => (
        <div className="d-flex align-items-center">
          <img src={showURLs[index]} width="40px" height="40px" />
          <span className="text-capitalize    text-nowrap">
            {row?.fullName}
          </span>
        </div>
      ),
    },
    {
      Header: "EMAIL",
      body: "email",
      Cell: ({ row }) => <span className="    ">{row?.email}</span>,
    },
    {
      Header: "CHANNEL ID",
      body: "channelId",
      Cell: ({ row }) => (
        <span className="text-capitalize  text-nowrap">{row?.channelId}</span>
      ),
    },
  ];

  const handlePageChange = (pageNumber) => {
    setPage(pageNumber);
  };

  const handleRowsPerPage = (value) => {
    setPage(1);
    setSize(value);
  };

  return (
    <div>
      <div className="user-table mb-3">
        <div className="user-table-top">
          <div className="row align-items-start mb-3">
            <h5
              style={{
                fontWeight: "500",
                fontSize: "20px",
                marginBottom: "4px",
                marginTop: "5px",
              }}
            >
              User Channel Table
            </h5>
          </div>

          <DataActions
            searchInputProps={{
              placeholder: "Search for ID, Name, Email",
              value: searchText,
              onValueChange: (value) => setSearchText(value),
            }}
          />
        </div>

        <Table
          data={data}
          mapData={channelAllUser}
          noDataMessage="No Channel Found!"
        />
        <Pagination
          totalItem={totalUserChannel}
          activePage={page}
          pageSize={size}
          onActivePageChange={handlePageChange}
          onPageSizeChange={handleRowsPerPage}
        />
      </div>
    </div>
  );
}
export default connect(null, {
  getUserChannels,
})(UserChannel);
